<template>
  <div id="app">
    <v-app>
    <router-view v-if="getParams.publicToken !== ''"></router-view>
    </v-app>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'app',
  computed: {
    ...mapGetters([
      'getShappyInfo',
      'getParams'
    ])
  },
  methods: {
    ...mapActions([
      'getShappyInfoAPI',
      'getCurrencyAPI',
      'sendShappyPostMessage',
      'initCart',
      'setCategoriesCurrentId',
      'setParams'
    ]),
    initShopCart (publicToken, shappyCustomToken, appId, channelId, primaryColor, secondaryColor, shappyInfo, language, domain) {
      let rpcartContainer = document.getElementById('rp-cart-container')
      let firstname = shappyInfo.firstname
      let lastname = shappyInfo.lastname
      let email = shappyInfo.email
      let mobile = shappyInfo.mobile
      let member = shappyInfo.member

      this.$i18n.set(language)
      this.$vuetify.theme.primary = primaryColor
      this.$vuetify.theme.secondary = secondaryColor

      this.initCart({
        publicToken,
        shappyCustomToken,
        appId,
        channelId,
        primaryColor,
        secondaryColor,
        language,
        firstname,
        lastname,
        email,
        mobile,
        member,
        domain
      }).then(result => {
        rpcartContainer.innerHTML = result
      })
    }
  },
  created () {
    this.sendShappyPostMessage().then(result => {
      this.getShappyInfoAPI({
        shappyCustomToken: result.customToken,
        appId: result.appId,
        channelId: result.channelId
      }).then(result2 => {
        if (result2.enable === '1') {
          this.setCategoriesCurrentId(result2.categoryId)
          this.$localStorage.set('token', result2.publicShopKey)
          this.getCurrencyAPI()

          if (result2.user.data.member === true) {
            result2.user.data.member = 1
          } else {
            result2.user.data.member = 0
          }
          this.setParams({
            publicToken: result2.publicShopKey,
            shappyCustomToken: result.customToken,
            appId: result.appId,
            channelId: result.channelId,
            primaryColor: result.colorMain,
            secondaryColor: result.colorSub,
            member: result2.user.data.member,
            language: result.lang,
            domain: result.domain
          })

          this.initShopCart(result2.publicShopKey, result.customToken, result.appId, result.channelId,
            result.colorMain, result.colorSub, result2.user.data, result.lang, result.domain)
        } else {
          this.setParams({
            publicToken: 'noshop'
          })
        }
      })
    })
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: rgba(0, 0, 0, 0);
}

::-webkit-scrollbar {
  display: none;  // Safari and Chrome
}

.rp-buy-button {
  width: 100%;
  height: 100%;
}

.rp-buy-button > span {
  margin: auto;
}

.rp-cart-button {
  background-color: rgba(0, 0, 0, 0) !important;
  border-color: rgba(0, 0, 0, 0) !important;
}

.application {
  .slider {
    .slider-item {
      z-index: 0 !important;
    }
    .btn {
      box-shadow: none !important;;
      margin: 0px !important;
      z-index: 2 !important;

      .slider-icon {
        border-left: 5px solid hsla(0,0%,100%,.6);
        border-bottom: 5px solid hsla(0,0%,100%,.6);
      }

      &:hover {
        .slider-icon {
          border-color: #ffffff;
        }
      }
    }

    .btn-left {
      background: rgba(0, 0, 0, 0) !important;
    }

    .btn-right {
      background: rgba(0, 0, 0, 0) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue